export default "__VITE_ASSET__LeepcNfk__"